<ambita-login>
  <div class="infoland-login">
    <form onsubmit="{ login }" if="{ !user }">
      <input type="text" class="infoland-login__input-username"
        placeholder="{ i18n.login.usernameLabel }" ref="usernameInput"/>
      <input type="password" class="infoland-login__input-password"
        placeholder="{ i18n.login.passwordLabel }" ref="passwordInput"/>
      <button type="submit" class="infoland-button">{ i18n.login.loginBtn }</button>
    </form>
    <div if="{ user }">
      <div class="infoland-login__user-info">
        { user.name } { user.email }<br>
        <infoland-date infoland-date-value="{ new Date() }"></infoland-date><br>
      </div>
      <button type="button" class="infoland-button" onclick="{ logout }">
        { i18n.login.logoutBtn }
      </button>
    </div>
  </div>

  <script>
    import './loginTranslations';
    import { init } from './loginController';

    init(this);
  </script>
</ambita-login>
